import styled, { css, keyframes } from 'styled-components';
import { rgba } from 'foundations-components/transitional/utils/color';
import FloatyWrapper from './FloatyWrapper';
import { calculateAnimationRenderOffset } from '../../utils/animation';
import { jsx as _jsx } from "react/jsx-runtime";
const fadeInAnimation = keyframes(["from{opacity:0}to{opacity:1}"]);
const pulseAnimation = ({
  theme
}) => keyframes(["0%{box-shadow:0 0 0 0 ", ";}70%{box-shadow:0 0 0 6px ", ";}100%{box-shadow:0 0 0 6px ", ";}"], rgba(theme.color['fill-accent-purple-default'], 0.7), rgba(theme.color['fill-accent-purple-default'], 0), rgba(theme.color['fill-accent-purple-default'], 0));
const RoundButton = styled.button.withConfig({
  displayName: "CoachingTipButton__RoundButton",
  componentId: "sc-9h6gyd-0"
})(({
  animationRenderOffset,
  theme: _theme
}) => {
  const theme = _theme;
  return css(["width:", ";height:", ";color:", ";background-color:", ";border-radius:", ";border:", ";font-size:", ";font-weight:", ";opacity:0;&:hover{background-color:", ";}animation:", " 2s ", "s infinite,", " 0.5s ", "s forwards;"], theme.space[800], theme.space[800], theme.color['text-primary-on-fill-default'], theme.color['fill-accent-purple-default'], theme.borderRadius[300], theme.borderWidth[0], theme.typography['body-125'].fontSize, theme.typography['body-125'].fontWeight, theme.color['fill-accent-purple-pressed'], pulseAnimation, animationRenderOffset * 0.4, fadeInAnimation, animationRenderOffset * 0.4);
});
const CoachingTipButton = ({
  onTipClick,
  onTipRender,
  onTipUnmount,
  placement,
  target,
  tipId,
  tipIndex,
  zIndex,
  isEmptyTarget
}) => {
  const handleAnimationEnd = () => {
    const thisTipElement = document.querySelector(`[data-coaching-tips-button="${tipId}"`);
    if (thisTipElement) {
      thisTipElement.classList.add('finished-animating');
    }
  };
  return /*#__PURE__*/_jsx(FloatyWrapper, {
    onTipRender: onTipRender,
    onTipUnmount: onTipUnmount,
    placement: placement,
    target: target,
    zIndex: zIndex,
    isEmptyTarget: isEmptyTarget,
    children: /*#__PURE__*/_jsx(RoundButton, {
      onAnimationEnd: handleAnimationEnd,
      animationRenderOffset: calculateAnimationRenderOffset(tipIndex - 1),
      "data-coaching-tips-button": tipId,
      "data-test-id": `${tipId}-coaching-tip-button`,
      "tip-index": tipIndex,
      onClick: onTipClick,
      children: "i"
    })
  });
};
export default CoachingTipButton;